var noop = function noop() {
  return null;
};

export default {
  color: noop,
  spacingUnit: noop
};